module.exports = __webpack_public_path__ + "img/desserts.0b4c5f2a.webp";